import { Link } from "react-router-dom";

import { Logo } from "@/components/Logo";
import { BRAND } from "@/lib/site";
import { allRoles } from "@/lib/roles";

/**
 * Three-column footer. First column is brand, then nav groups, then legal.
 * Includes a curated list of 12 top roles for SEO crawlability plus a
 * "Browse all X roles" link.
 */
export function Footer() {
  const allRolesList = allRoles();
  const roles = allRolesList.slice(0, 12);
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border/70 bg-ink text-cream">
      <div className="container grid grid-cols-1 gap-12 py-16 md:grid-cols-4">
        <div>
          <div className="[&_span]:text-cream">
            <Logo />
          </div>
          <p className="mt-4 max-w-xs text-sm text-cream/75">
            Zero-setup, role-ready AI agents. Pick your role, press go.
          </p>
        </div>

        <nav aria-labelledby="footer-product">
          <h2 id="footer-product" className="mb-4 text-sm font-semibold uppercase tracking-wide text-cream">
            Product
          </h2>
          <ul className="space-y-2 text-sm text-cream/75">
            <li><Link to="/for" className="hover:text-cream">Role agents</Link></li>
            <li><Link to="/integrations" className="hover:text-cream">Integrations</Link></li>
            <li><Link to="/pricing" className="hover:text-cream">Pricing</Link></li>
            <li><Link to="/vs/openclaw" className="hover:text-cream">vs OpenClaw</Link></li>
          </ul>
        </nav>

        <nav aria-labelledby="footer-roles">
          <h2 id="footer-roles" className="mb-4 text-sm font-semibold uppercase tracking-wide text-cream">
            Popular roles
          </h2>
          <ul className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm text-cream/75">
            {roles.map((r) => (
              <li key={r.slug}>
                <Link to={`/for/${r.slug}`} className="hover:text-cream">
                  {r.title}
                </Link>
              </li>
            ))}
            <li className="col-span-2 pt-2">
              <Link to="/for" className="font-medium text-coral-400 hover:text-coral-300">
                Browse all {allRolesList.length} roles →
              </Link>
            </li>
          </ul>
        </nav>

        <nav aria-labelledby="footer-company">
          <h2 id="footer-company" className="mb-4 text-sm font-semibold uppercase tracking-wide text-cream">
            Company
          </h2>
          <ul className="space-y-2 text-sm text-cream/75">
            <li><Link to="/about" className="hover:text-cream">About</Link></li>
            <li><a href="#privacy" className="hover:text-cream">Privacy</a></li>
            <li><a href="#terms" className="hover:text-cream">Terms</a></li>
            <li><a href="#accessibility" className="hover:text-cream">Accessibility (AODA/WCAG)</a></li>
          </ul>
        </nav>
      </div>

      <div className="border-t border-cream/10">
        <div className="container flex flex-col items-start justify-between gap-2 py-6 text-xs text-cream/60 md:flex-row md:items-center">
          <p>© {year} {BRAND}. All rights reserved.</p>
          <p>Accessible by design. WCAG 2.1 AA &amp; AODA conformant.</p>
        </div>
      </div>
    </footer>
  );
}
